export default __webpack_public_path__ + "static/media/book_freedom_b_guide.00d46bc6.png";